export default function SearchHistory() {
    return {
        restrict: "E",
        scope: {},
        replace: false,
        template: require("./search-history.html"),

        controller: function (
            $scope,
            $rootScope,
            houseService,
            searchHistoryFactory
        ) {
            // Ugly fix -- Kill the backdrop
            var seachUpdateEventListener = $scope.$on(
                "search-updated-broadcast",
                function (event, args) {
                    searchHistoryFactory.ViewType = args.ViewType;
                    $scope.searchFilter = houseService.searchFilter;
                    $scope.searchResults = houseService.searchResults;

                    $scope.history = searchHistoryFactory.history;

                    if (searchHistoryFactory.ViewType == 3) {
                        //if( searchHistoryFactory.history.indexOf(args) == -1 ){

                        searchHistoryFactory.storeUserSearch(args);
                    }
                }
            );
            $scope.$on("$destroy", seachUpdateEventListener);

            $scope.selectStoredSearch = function (storedSearch) {
                // if (
                //     searchHistoryFactory.history.indexOf(storedSearch) == -1
                // ) {
                // }
                houseService = storedSearch;
                // console.log(houseService.searchFilter.houseType.Name);

                // console.log(houseService);

                //houseService.searchFilter.searchNow()
            };

            $scope.activateHistoryTab = function () {};

            $scope.scrollToElem = function (elemID, offset) {
                $rootScope.$broadcast(
                    "scroll-to-elem-broadcast",
                    elemID,
                    offset
                );
            };
        },
    };
}
